module.exports = __webpack_public_path__ + "5b6c8fa4b519d9b0879c27b8d761c92f.png";